// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Halogen_Query_Input = require("../Halogen.Query.Input/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Foreign_Render = require("../Lunarbox.Foreign.Render/index.js");
var Record = require("../Record/index.js");
var Rerender = (function () {
    function Rerender(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Rerender.create = function (value0) {
        return function (value1) {
            return new Rerender(value0, value1);
        };
    };
    return Rerender;
})();
var RequestRerender = (function () {
    function RequestRerender() {

    };
    RequestRerender.value = new RequestRerender();
    return RequestRerender;
})();
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var canvasRef = function (id) {
    return Halogen_Query_Input.RefLabel("canvas-" + Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(id));
};
var component = function (dictMonadEffect) {
    var render = function (v) {
        return Halogen_HTML_Elements.canvas([ Halogen_HTML_Properties.width(75), Halogen_HTML_Properties.height(75), Halogen_HTML_Properties.ref(canvasRef(v.name)), Lunarbox_Component_Utils.className("node__preview") ]);
    };
    var handleQuery = function (v) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(canvasRef)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
            return v1.name;
        })))(function (ref) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Foreign_Render.withContext(dictMonadEffect)(ref)(function (ctx) {
                return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Lunarbox_Foreign_Render.renderPreview(ctx)(v.value0));
            }))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        });
    };
    var handleAction = function (v) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(canvasRef)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
            return v1.name;
        })))(function (ref) {
            return Lunarbox_Foreign_Render.withContext(dictMonadEffect)(ref)(function (v1) {
                return Halogen_Query_HalogenM.raise(RequestRerender.value);
            });
        });
    };
    return Halogen_Component.mkComponent({
        initialState: Record.merge()()({
            context: Data_Maybe.Nothing.value
        }),
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: handleAction,
            handleQuery: handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: new Data_Maybe.Just(Init.value),
            finalize: Halogen_Component.defaultEval.finalize
        })
    });
};
module.exports = {
    Rerender: Rerender,
    RequestRerender: RequestRerender,
    component: component
};
